import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BaseButtonComponent } from '@d-components';
import { ModalService } from '@d-services';

@Component({
  selector: 'app-confirm-popup',
  templateUrl: './confirm-popup.component.html',
  styleUrls: ['./confirm-popup.component.scss'],
  standalone: true,
  imports: [CommonModule, BaseButtonComponent, TranslateModule],
})
export class ConfirmPopupComponent {
  @Input() confirmMessage: string = '';
  @Input() confirmMessageParams: any = {};

  @Input() itemName: string = '';
  @Input() cancelText: string = 'NO';
  @Input() submitText: string = 'YES';
  constructor(private modalService: ModalService) {}

  closeDialog(type?: string) {
    const res = { actionType: type } as any;
    this.modalService.closeModal(res);
  }
}
